const toCamel = (s: string): string => {
  return s.replace(/([-_][a-z])/gi, $1 => {
    return $1.toUpperCase().replace('_', '')
  })
}

const isObject = (o: any): boolean => {
  return o === Object(o) && !Array.isArray(o) && typeof o !== 'function'
}

// This function will recursively convert all keys in an object.
export const keysToCamel = (o: any): any => {
  if (isObject(o)) {
    const n: { [key: string]: any } = {}
    Object.keys(o).forEach(k => {
      n[toCamel(k)] = keysToCamel(o[k])
    })
    return n
  } else if (Array.isArray(o)) {
    return o.map(i => keysToCamel(i))
  }
  return o
}
